import React from 'react';

import Skeleton from 'react-loading-skeleton';

import { SkeletonButtonWrapper, SkeletonTextWrapper, SkeletonWrapper } from './styled';

export const TimsRewardsPointsSectionSkeleton = () => {
  return (
    <SkeletonWrapper>
      <SkeletonTextWrapper>
        <Skeleton count={2} />
        <Skeleton width={'50%'} />
      </SkeletonTextWrapper>
      <SkeletonButtonWrapper>
        <Skeleton height={'100%'} />
      </SkeletonButtonWrapper>
    </SkeletonWrapper>
  );
};
